import Users from './Users';

const UsersPage = ({ isAdmin }) => {
  if (!isAdmin) {
    return (
      <div>
        <h1>Access denied</h1>
        <p>You do not have permission to access this page.</p>
      </div>
    );
  }

  return <Users />;
};

export default UsersPage;
